export enum IUSER_NOTIFICATION_STATUS {
  READ = 'read',
  UNREAD = 'unread',
}

export enum IUSER_NOTIFICATION_TYPES {
  CALENDAR_MEETING = 'Calendar Meeting',
  CALENDAR_MEETING_RESCHEDULED = 'Calendar Meeting Rescheduled',
  CALENDAR_MEETING_CANCELLED = 'Calendar Meeting Cancelled',
  CALENDAR_MEETING_UPDATED = 'calendar.meeting.updated',
  CHAT = 'Chat',
  CHAT_TAG = 'Chat Tag',
  CHAT_MESSAGE_EDITED = 'Chat Message Edited',
  CLIENT_USER_PROFILE_UPDATE = 'Client User Profile Update',
  CLIENT_BUSINESS_PROFILE_UPDATE = 'Client Business Profile Update',
  NEW_CLIENT_ADDED = 'New Client Added',
  CLIENT_REMOVED = 'Client Removed',
  MONTHLY_ATTESTATION_TIME = 'Monthly Attestation Time',
  USER_DISABLED = 'User Disabled',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  MONTHLY_ATTESTATION_UPDATE = 'Monthly Attestation Update',
  INTERNAL_ANNOUNCEMENT = 'Internal Announcement',
  PLAN_START_DATE = 'Plan Start Date',
  SUGGESTED_GOAL_MESSAGE = 'Suggested Goal Message',
  ACCEPTED_GOAL_MESSAGE = 'Accepted Goal Message',
  DECLINED_GOAL_MESSAGE = 'Declined Goal Message',
  SUGGESTED_PLAY_MESSAGE = 'Suggested Play Message',
  ACCEPTED_PLAY_MESSAGE = 'Accepted Play Message',
  DECLINED_PLAY_MESSAGE = 'Declined Play Message',
  PLAY_COMMENT_ADDED = 'Play Comment Added',
  PLAY_COMMENT_REPLY = 'Play Comment Reply',
  PLAY_COMMENT_MENTION = 'Play Comment Mention',
  PLAY_COMMENT_REPLY_MENTION = 'Play Comment Reply Mention',
  PLAY_COMMENT_THREAD = 'Play Comment Thread',
  MEETING_ACTION_ITEM_ADD = 'Add Meeting Action Item',
  CALENDAR_NOTE_TAGGED = 'Meeting Note Tagged',
}
export enum ROLES {
  ADMIN = 'ADMIN',
  BSO_ADMIN = 'BSO_ADMIN',
  BSO_ADVISOR = 'BSO_ADVISOR',
  BUSINESS_OWNER = 'BUSINESS_OWNER',
}
